import "./SubscribeButton.scss";

import { Button } from "@fluentui/react-northstar";
import React, { useState } from "react";

import { usePaymentRedirect } from "../../actions/usePaymentRedirect";
import { useUserInfo } from "../../actions/useUserInfo";
import { clientEventTracker } from "../../utils/clientTelemetry";
import { PollyDialog } from "../PollyDialog";
import { PollyIcon } from "../PollyIcon";
import { PaymentRedirectPlaceholder } from "./PaymentRedirectPlaceholder";

export type SubscribeButtonProps = {
  trackingName: string;
  onDone?: () => void;
  caption?: string;
};

export const SubscribeButton: React.FC<SubscribeButtonProps> = ({
  children,
  trackingName,
  onDone,
  caption,
}) => {
  const { loadUser, user } = useUserInfo();
  const [isCheckoutOpen, setIsCheckoutOpen] = useState<boolean>(false);
  const { openPaymentPage } = usePaymentRedirect();

  const onSubscribeClick = () => {
    clientEventTracker.track("UpgradeButton clicked", user, {
      trackingSource: trackingName,
    });
    openPaymentPage(trackingName);
    setIsCheckoutOpen(true);
  };

  if (isCheckoutOpen) {
    return (
      <PollyDialog
        width="90vw"
        maxWidth="700px"
        onCancel={() => {
          loadUser(true);
          setIsCheckoutOpen(false);
          if (onDone) {
            onDone();
          }
        }}
        closeOnOutsideClick={false}
        open={isCheckoutOpen}
      >
        <PaymentRedirectPlaceholder
          actionText="Close"
          trackingSource={trackingName}
          onActionClick={() => {
            loadUser();
            setIsCheckoutOpen(false);
            if (onDone) {
              onDone();
            }
          }}
        />
      </PollyDialog>
    );
  }

  if (children) {
    return (
      <Button text fluid className="subscribe-button__children" onClick={() => onSubscribeClick()}>
        {children}
      </Button>
    );
  }

  return (
    <Button
      fluid
      primary
      className="usermenu__menu_button"
      content={<PollyIcon icon="pay-icon" label={caption || "Subscribe"} inheritColor />}
      onClick={() => {
        onSubscribeClick();
      }}
    />
  );
};
